<template>
  <div class="row" v-if="msg.length">
    <ul class="list-group">
      <li class="list-group-item bg-info" v-for="m in msg" :key="m">
        {{ m }}
      </li>
    </ul>
  </div>
  <div class="row" v-if="err.length">
    <ul class="list-group">
      <li class="list-group-item bg-warning" v-for="e in err" :key="e">
        {{ e }}
      </li>
    </ul>
  </div>
  <div class="row d-flex align-items-center border border-success">
    <div class="col-3">
      <input
        type="text"
        class="form-control"
        placeholder="Name"
        v-model.trim="name"
      />
    </div>

    <div class="col">
      <input
        type="text"
        class="form-control"
        placeholder="Wallet"
        v-model.number="wallet_size"
      />
    </div>
    <div class="col">
      <input
        type="text"
        class="form-control"
        placeholder="Increment"
        v-model.number="increment"
      />
    </div>
    <div class="col">
      <input
        type="text"
        class="form-control"
        placeholder="Team headcount"
        v-model.number="team_size"
      />
    </div>
    <div class="col">
      <button class="btn btn-sm btn-primary" @click="addAuction()">Add</button>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
import { ref } from "vue";
const store = useStore();
const name = ref("");
const wallet_size = ref(null);
const increment = ref(null);
const team_size = ref(null);
const err = ref([]);
const msg = ref([]);
const addAuction = async () => {
  checkConditions();
  if (!err.value.length) {
    const insObj = {
      name: name.value,
      wallet_size: wallet_size.value,
      team_size: team_size.value,
      bid_increment: increment.value,
      active: false,
    };
    const { data, error } = await supabase
      .from("auctions")
      .insert([insObj])
      .select();
    if (!error) {
      msg.value.push("Auction added!");
      clearData();
      store.setAction("");
    } else {
      console.log(error);
      msg.value.push(error.message);
    }
    setTimeout(() => {
      msg.value = [];
    }, 1000);
  }
};
const checkConditions = () => {
  err.value = [];
  if (!name.value) {
    err.value.push("Auction name required");
  }
  if (!wallet_size.value) {
    err.value.push("Wallet amount required");
  }
  if (!isNumber(wallet_size.value)) {
    err.value.push("Wallet should be number");
  }
  if (!increment.value) {
    err.value.push("Increment amount required");
  }
  if (!isNumber(increment.value)) {
    err.value.push("Increment should be number");
  }
  if (!team_size.value) {
    err.value.push("Team size required");
  }
  if (!isNumber(team_size.value)) {
    err.value.push("Team size should be number");
  }
};
function isNumber(value) {
  return typeof value === "number";
}
const clearData = () => {
  name.value = "";
  wallet_size.value = null;
  increment.value = null;
  team_size.value = null;
};
</script>
